import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Toggle from './Toggle';

const DarkModeSettings = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // Check if dark mode is enabled in localStorage
    const darkMode = localStorage.getItem('darkMode') === 'true';
    setIsDarkMode(darkMode);
    if (darkMode) {
      document.documentElement.classList.add('dark');
    }
  }, []);

  const handleToggle = () => {
    const newDarkMode = !isDarkMode;
    setIsDarkMode(newDarkMode);
    localStorage.setItem('darkMode', newDarkMode);
    
    if (newDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className="flex flex-col justify-start items-start flex-wrap p-4 gap-4 w-full max-w-2xl"
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.15 }}
        className="w-full bg-white dark:bg-slate-50/5 rounded-lg shadow-sm p-4 border border-slate-200 dark:border-slate-700"
      >
        <h2 className="text-lg font-medium text-slate-800 dark:text-slate-200 mb-3">
          Dark Mode Settings
        </h2>
        <p className="text-sm text-slate-600 dark:text-slate-400 mb-4">
          Customize your viewing experience by enabling or disabling dark mode. Dark mode reduces eye strain in low-light environments.
        </p>
        <Toggle
          isOn={isDarkMode}
          onToggle={handleToggle}
          label="Enable Dark Mode"
        />
      </motion.div>
    </motion.div>
  );
};

export default DarkModeSettings; 